import React from 'react';
import Link from 'gatsby-link';

import mastheadImg from '../../images/man-walking-up-stairs.jpg';
import ElementParallax from '../../components/ElementParallax';

import styles from './masthead.module.css';

const Masthead = () => (
    <div className={styles.masthead}>
        <ElementParallax>
            <img src={mastheadImg} alt='Unlock your export potential with Artiseq' />
        </ElementParallax>

        <h1 className={styles.valueProp}>Unlock your exporting potential</h1>
    </div>
)

export default Masthead;



// WEBPACK FOOTER //
// ./src/components/Masthead/index.js